import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
declare var $: any;
declare var bootstrap: any;

@Injectable({
  providedIn: 'root'
})
export class Helpers {

  isApiUrl(req: any) {
    if (req.url.startsWith(environment.urlAPI)) {
      return true;
    }
    return false;
  }

  isSameOriginUrl(req: any) {
    // It's an absolute url with the same origin.
    if (req.url.startsWith(`${window.location.origin}/`)) {
      return true;
    }

    // It's a protocol relative url with the same origin.
    // For example: //www.example.com/api/Products
    if (req.url.startsWith(`//${window.location.host}/`)) {
      return true;
    }

    // It's a relative url like /api/Products
    if (/^\/[^\/].*/.test(req.url)) {
      return true;
    }

    // It's an absolute or protocol relative url that
    // doesn't have the same origin.
    return false;
  }

  setDataTableSearchDelay() {
    var searchDelay = null;

    setTimeout(function () {
      $('.dt-search input')
        .off('keyup.DT search.DT input.DT paste.DT cut.DT')
        .on('keyup.DT search.DT input.DT paste.DT cut.DT', function () {
          var search = $('.dt-search input').val();
          clearTimeout(searchDelay);

          searchDelay = setTimeout(function () {
            if (search != null) {
              $.fn.dataTable.tables({ api: true, visible: true }).search(search).draw();
            }
          }, 1000);
        });
    }, 1000);
  }

  getFormData(obj: any, form?: FormData, namespace?: string): FormData {
    const that = this;
    const fd = form || new FormData();

    for (const property in obj) {
      if (!obj.hasOwnProperty(property) || obj[property] === undefined || obj[property] === null) {
        continue;
      }

      const value = obj[property];

      if (value instanceof Date) {
        const formKey = namespace ? `${namespace}[${property}]` : property;
        fd.append(formKey, value.toISOString());
      } else if (value instanceof File) {
        const formKey = namespace ? `${namespace}.${property}` : property;
        fd.append(formKey, value);
      } else if (Array.isArray(value)) {
        value.forEach((element, index) => {
          const formKey = namespace ? `${namespace}[${property}]` : property;
          const tempKey = `${formKey}[${index}]`;
          if (typeof element === 'object' && element !== null) {
            that.getFormData(element, fd, tempKey);
          } else {
            fd.append(tempKey, element);
          }
        });
      } else if (typeof value === 'object') {
        const formKey = namespace ? `${namespace}[${property}]` : property;
        that.getFormData(value, fd, formKey);
      } else {
        const formKey = namespace ? `${namespace}[${property}]` : property;
        fd.append(formKey, value);
      }
    }

    return fd;
  }

  formatDateForInput(date: Date | string): string {
    if (!date) return null;
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getMonths() {
    let mesesDelAnio: { value: number; label: string }[] = [
      { value: 1, label: 'Enero' },
      { value: 2, label: 'Febrero' },
      { value: 3, label: 'Marzo' },
      { value: 4, label: 'Abril' },
      { value: 5, label: 'Mayo' },
      { value: 6, label: 'Junio' },
      { value: 7, label: 'Julio' },
      { value: 8, label: 'Agosto' },
      { value: 9, label: 'Septiembre' },
      { value: 10, label: 'Octubre' },
      { value: 11, label: 'Noviembre' },
      { value: 12, label: 'Diciembre' },
    ];
    return mesesDelAnio;
  }

  /**
   * Comprueba si estamos en un entorno de desarrollo
   * Usa como referencia la URL de la API
   */
  isInDevEnvironment() {


    // It's a development local url.
    if (environment.urlAPI.startsWith('https://localhost')) {
      return true;
    }

    return false;
  }

  formatMinutesToHoursAndMinutes(minutes: number): string {
    if (!minutes || minutes === 0) {
      return '0 minutos';
    }

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = Math.round(minutes % 60);

    if (hours === 0) {
      return `${remainingMinutes}m`;
    }

    if (remainingMinutes === 0) {
      return `${hours}h`;
    }

    return `${hours}h ${remainingMinutes}m`;
  }

  /**
   * Activa los tooltips de Bootstrap
   * Usado tras un cambio en el DOM
   * Sobre todo en los datatables
   */
  enableBsTooltips() {
    $('.tooltip').remove();
    var tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipElements.forEach(function (tooltipElement) {
      $('.tooltip').remove();
      var tooltip = bootstrap.Tooltip.getOrCreateInstance(tooltipElement);
    });
    $('[data-bs-toggle="tooltip"]').on("mousedown", function () {
      $('.tooltip').remove();
    });
  }

  clearBsTooltips() {
    $('.tooltip').remove();
  }

  enableBsPopovers() {
    $('.popover').remove();
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl)
    });
  }

  clearBsPopovers() {
    $('.popover').remove();
  }

}
